import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import UpiVpa from '../../filters/UpiVpa.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
class UpiVpaHandlerReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            issuerBankIds:'',
            acqBankIds:'',
            is_aggr:1,
            ciutidIds: '',
            store_filter: true,
            show_acq_issuer:true,
            selected_tab:'Summary',
            vpa:""
        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        if(decoded.userType==='Internal') {

            isReportAccess(AllAccessPermissions, 'upi_vpa_handler_report');
        }
        else {
             if(this.props.location.state!='MAVE0001')
             {
                this.unauthorize_access();
             }

        }

        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });

    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    componentDidUpdate() {

    }
    componentDidMount() {
        if(this.state.selected_tab==='Summary'){
            this.setState({
                //show_acq_issuer: false,
                selected_tab: this.state.selected_tab
            })
            this.get_vpa_upi_handler_summary(this.state.object_type,this.state.object_code,'','');
        }
        else {
            this.setState({
                //show_acq_issuer: true,
                selected_tab: this.state.selected_tab
            })
            this.get_vpa_upi_handler_details(this.state.object_type,this.state.object_code,'','');
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'upi_vpa_handler_report','sparcs')
    }

    get_all_txn_summary(object_type, object_code, selected_tab, event){

    if(selected_tab==='Summary'){
        this.setState({
            //show_acq_issuer: false,
            selected_tab: selected_tab
        })
        setTimeout(function(){
            this.get_vpa_upi_handler_summary(object_type, object_code, event);

        }.bind(this), 200);
    }
    else {
        this.setState({
            //show_acq_issuer: true,
            selected_tab: selected_tab
        })
        setTimeout(function(){
            this.get_vpa_upi_handler_details(object_type, object_code, event);

        }.bind(this), 200);
    }



    }
    get_vpa_upi_handler_summary(object_type, object_code, event) {
        this.setState({
            selected_tab:'Summary'
        })
        var that = this;

        isApiResponse(false);
//         var merchants = this.state.merchantID;
//         var chains = this.state.chainID;
//         var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }

        var postData = {
            vpa: this.state.vpa,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            type:'Summary'
        };
        if ($.fn.DataTable.isDataTable('#VpaUpiSummaryTable')) {
            $('#VpaUpiSummaryTable').DataTable().clear().destroy();
        }
        var VpaUpiSummaryTable = $('#VpaUpiSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "ordering": false,
                "responsive": false,
                "dom": "lfrti",
                //"scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/upi-vpa-handler",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [

                    {"data":"vpa"},
                    {"data": "count_greater_than_2000"},
                    {"data":"Amount_greater_than_2000"},
                    {"data":"count_upto_2000"},
                    // {"data": "transaction_date"},
                    {"data": "Amount_upto_2000"},
                    {"data": "Total count"},
                    {"data": "Total Amount"},

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 1,2,3,4,5,6],
                        "className": "text-right"
                    },

                ],
            });
    }
    get_vpa_upi_handler_details(object_type, object_code, event) {

        var that = this;
        this.setState({
            selected_tab:'Details'
        })

        isApiResponse(false);
//         var merchants = this.state.merchantID;
//         var chains = this.state.chainID;
//         var stores = this.state.storeID;
//         if(object_type === 'Merchant' && this.state.merchantID===''){
//             merchants = object_code;
//         }
//         if(object_type==='Chain' && this.state.chainID===''){
//             chains = object_code;
//         }
//         if(object_type==='Store' && this.state.storeID===''){
//             stores = object_code;
//         }

        var postData = {
            vpa: this.state.vpa,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            type:'Details'
        };
        if ($.fn.DataTable.isDataTable('#VpaUpiDetailsTable')) {
            $('#VpaUpiDetailsTable').DataTable().clear().destroy();
        }
        var VpaUpiDetailsTable = $('#VpaUpiDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                "ordering": false,
                // "scrollX": true,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/upi-vpa-handler",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"transaction_date"},
                    {"data": "vpa"},
                    {"data": "count_greater_than_2000"},
                    {"data": "Amount_greater_than_2000"},
                    {"data": "count_upto_2000"},
                    // {"data": "transaction_date"},
                    {"data": "Amount_upto_2000"},
                    {"data": "Total count"},
                    {"data": "Total Amount"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 2,3,4,5,6,7],
                        "className": "text-right"
                    },

                ],
            });
    }
    
    VpaUpiDownloadCheck(type, e){
    var filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            vpa: this.state.vpa,
            download: 1
        };
        var fn = '';
        var url = '';
        if(type==='Summary'){
            fn='UPI_VPA_handler_Txn_Summary.csv.gz';
            url = '/summary_reports/upi/transaction/summary';
        }
        if(type==='Details'){
            fn='UPI_VPA_handler_Txn_Details.csv.gz';
            url = '/summary_reports/dmart_upi_vpa_handler';
        }

    if(this.state.vpa===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, url, fn, 30);
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, url, fn, 30);
        }
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        this.refs.upiVpa.restVpaFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            vpa:'',

            isChange: false,
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleVpa = (optionSelected, vpa) =>
    {
        this.setState({
            vpa:vpa,
            isChange: true,

        });

    }



    render() {

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">UPI VPA Handler Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> VPA: </label>
                                                <UpiVpa ref="upiVpa" onSelectUpiVpa = {this.handleVpa}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        <button id='apply_btn' type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_all_txn_summary.bind(this, this.state.object_type,this.state.object_code, this.state.selected_tab)}>Apply</button>
                                        <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'Summary', '')}>UPI VPA Handler Summary</Tab>
                                            <Tab onClick={()=>this.get_all_txn_summary(this.state.object_type,this.state.object_code,'Details','')}>UPI VPA Handler Details</Tab>
                                        </TabList>

                                        <TabPanel>

                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.VpaUpiDownloadCheck.bind(this,'Summary')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="VpaUpiSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>

                                                    <th>VPA</th>
                                                    <th>Count greater than 2000</th>
                                                    <th>Amount greater than 2000</th>
                                                    <th>Count upto 2000</th>
                                                    <th>Amount upto 2000</th>
                                                    <th>Total Count</th>
                                                    <th>Total Amount</th>


                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                        </div>

                                        </TabPanel>
                                        <TabPanel>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">

                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.VpaUpiDownloadCheck.bind(this,'Details')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix"></div>
                                        <table id="VpaUpiDetailsTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Transaction Date</th>
                                                <th>VPA</th>
                                                <th>Count greater than 2000</th>
                                                <th>Amount greater than 2000</th>
                                                <th>Count upto 2000</th>
                                                <th>Amount upto 2000</th>
                                                <th>Total Count</th>
                                                <th>Total Amount</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                        </TabPanel>

                                        </Tabs>
                                        <div className="clearfix"></div>

                                    </div>

                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( UpiVpaHandlerReport);